import React from 'react'
import { Skeleton } from '@fs/zion-ui'
import { css } from '@emotion/core'

const thumbnailWrapperCss = css`
  height: 56px;
  width: 100%;
  margin-block-end: var(--spacer-xs);
  overflow: hidden;
`

const headerWrapperCss = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`

const pillsRowCss = css`
  display: flex;
  gap: 4px;
  padding-block-end: var(--spacer-xs);
`

export default function SourceColumnHeaderSkeleton(): JSX.Element {
  return (
    <div css={headerWrapperCss} aria-hidden>
      <div css={thumbnailWrapperCss}>
        <Skeleton.Base style={{ width: '100%', height: '100%' }} />
      </div>
      <Skeleton.H5 />
      <div css={pillsRowCss}>
        <Skeleton.Chip minWidth={70} maxWidth={90} />
        <Skeleton.Chip minWidth={55} maxWidth={70} />
      </div>
    </div>
  )
}
